/* FFS deploy 20260708e — homepage video boot fix */
(function () {
  window.__ffsHeroSectionRefresh = true;

  function pickVideoUrl(video) {
    var desktop = video.getAttribute('data-src-desktop');
    var mobile = video.getAttribute('data-src-mobile');
    var useDesktop = window.matchMedia('(min-width: 750px)').matches;
    if (desktop || mobile) {
      return useDesktop ? desktop || mobile : mobile || desktop;
    }
    var sources = video.querySelectorAll('source');
    for (var i = 0; i < sources.length; i++) {
      var media = sources[i].getAttribute('media');
      if (!media || window.matchMedia(media).matches) {
        return sources[i].getAttribute('src');
      }
    }
    return video.getAttribute('src') || (sources[0] && sources[0].getAttribute('src'));
  }

  function markVideoReady(video) {
    if (!video) return;
    if (video.readyState >= 2 && (video.currentTime > 0 || !video.paused)) {
      video.classList.add('is-playing', 'is-frame-ready');
    }
  }

  function fixHeroVideos() {
    /* Let SlideshowComponent own homepage hero playback */
    if (document.body.classList.contains('template-index') && document.querySelector('slideshow-component .slideshow__video')) {
      return;
    }
    var css = document.getElementById('ffs-hero-video-css');
    if (css) css.remove();

    document.querySelectorAll('video.slideshow__video').forEach(function (video) {
      var slide = video.closest('.slideshow__slide');
      if (!slide || slide.getAttribute('aria-hidden') === 'true') return;

      var next = pickVideoUrl(video);
      if (!next) return;

      var current = video.currentSrc || video.getAttribute('src') || '';
      /* Only swap src when the art-directed URL actually differs — avoid load() hitch */
      if (current.indexOf(next.split('?')[0].split('/').pop()) === -1 && current !== next) {
        video.querySelectorAll('source').forEach(function (s) {
          s.remove();
        });
        video.setAttribute('src', next);
      }

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;

      if (!video.paused && video.readyState >= 2) {
        markVideoReady(video);
        return;
      }

      var play = video.play();
      if (play && play.then) {
        play.then(function () {
          markVideoReady(video);
          if (video.readyState < 2) {
            video.addEventListener('loadeddata', function () { markVideoReady(video); }, { once: true });
          }
        }).catch(function () {
          if (video.readyState >= 2) markVideoReady(video);
        });
      }
    });
  }

  function boot() {
    fixHeroVideos();
    /* One soft retry — do not stack load() loops with global.js */
    window.setTimeout(fixHeroVideos, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', fixHeroVideos);
})();

(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function unlockPageScroll() {
    document.body.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop'
    );
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.documentElement.style.overflow = '';

    document.querySelectorAll('product-modal[open], modal-dialog[open], cart-drawer.active').forEach((el) => {
      el.removeAttribute('open');
      el.classList.remove('active', 'animate');
    });

    document.querySelectorAll('details[open].menu-drawer-container, header-drawer details[open]').forEach((el) => {
      el.removeAttribute('open');
    });
  }

  function cancelAllScrollTriggers() {
    document.querySelectorAll('.scroll-trigger').forEach((el) => {
      el.classList.add('scroll-trigger--cancel');
      el.classList.remove('scroll-trigger--offscreen');
    });
  }

  function bootPage() {
    document.documentElement.classList.remove('ffs-motion-loading');
    document.documentElement.classList.add('ffs-motion-ready');
    cancelAllScrollTriggers();
  }

  function initHeader() {
    // Homepage header stays at the top of the page and scrolls away —
    // no floating / glass sticky treatment on scroll.
    if (document.body.classList.contains('template-index')) return;

    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    if (!headerGroup) return;

    const onScroll = () => {
      headerGroup.classList.toggle('floating-header', window.scrollY > 48);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initCrossfadeSlideshow() {
    document.querySelectorAll('slideshow-component').forEach((component) => {
      const slider = component.querySelector('.slideshow.banner');
      if (!slider || !document.body.classList.contains('template-index')) return;
      slider.classList.add('ffs-slideshow--crossfade');
    });
  }

  function observeReveal(el, observer) {
    if (el.classList.contains('ffs-reveal--visible')) return;
    el.classList.add('ffs-reveal');
    observer.observe(el);
  }

  function initReveals() {
    if (reducedMotion) return;
    if (!document.body.classList.contains('template-index')) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ffs-reveal--visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    document.querySelectorAll('.shopify-section').forEach((section, index) => {
      if (section.querySelector('slideshow-component')) return;
      if (section.querySelector('.newsletter')) return;
      if (section.querySelector('.testi-wall')) return;
      // Never animate the header/footer sections: ffs-reveal's will-change creates a
      // stacking context that traps the menu drawer below main content on mobile.
      if (
        section.classList.contains('section-header') ||
        section.classList.contains('announcement-bar-section') ||
        section.querySelector('sticky-header, header-drawer, .announcement-bar') ||
        section.closest('.shopify-section-group-header-group, .shopify-section-group-footer-group')
      )
        return;

      // Prefer the actual heading text node — never .collection__title (page-width
      // wrapper). ffs-section-label is display:inline-block for the underline, which
      // breaks margin:auto centering when applied to the wrapper.
      const heading = section.querySelector(
        '.collection__title .title, .title-wrapper-with-link .title, .collection-list-title, .ffs-kits-spot__title, h2.title, h2'
      );
      if (heading && !heading.classList.contains('ffs-reveal')) {
        heading.classList.add('ffs-section-label');
        heading.style.setProperty('--ffs-reveal-delay', '0ms');
        observeReveal(heading, observer);
      }

      const grid = section.querySelector('.product-grid, ul.grid, .collection-list');
      if (grid && !grid.classList.contains('ffs-stagger-grid')) {
        grid.classList.add('ffs-stagger-grid', 'ffs-reveal', 'ffs-reveal--scale');
        grid.style.setProperty('--ffs-reveal-delay', '80ms');
        grid.querySelectorAll('.grid__item, .slider__slide, .collection-list__item').forEach((item, i) => {
          item.style.setProperty('--ffs-stagger-index', String(i % 12));
        });
        observeReveal(grid, observer);
      } else if (!grid) {
        section.classList.add('ffs-reveal', 'ffs-reveal--fade');
        section.style.setProperty('--ffs-reveal-delay', `${Math.min(index, 6) * 60}ms`);
        observeReveal(section, observer);
      }
    });
  }

  function initCatchHero() {
    const widget = document.querySelector('.ffs-collection-hero--catch-float .ffs-catch-float');
    if (!widget) return;
    widget.classList.remove('ffs-catch-float--overlay');
    widget.style.position = '';
    widget.style.top = '';
    widget.style.left = '';
    widget.style.width = '';
    widget.style.height = '';
    widget.style.zIndex = '';
  }

  function initCommercePages() {
    const isCommercePage = ['template-collection', 'template-search', 'template-cart'].some((cls) =>
      document.body.classList.contains(cls)
    );
    if (!isCommercePage) return;

    initCatchHero();

    cancelAllScrollTriggers();

    document.querySelectorAll('.product-card-wrapper img, .product-grid img').forEach((img) => {
      img.style.opacity = '1';
      img.style.visibility = 'visible';
    });

    document.querySelectorAll('.ffs-stagger-grid, .ffs-product-grid--catch-slot').forEach((grid) => {
      grid.classList.add('ffs-reveal--visible');
      grid.querySelectorAll('.grid__item').forEach((item) => {
        item.classList.add('scroll-trigger--cancel');
        item.classList.remove('scroll-trigger--offscreen');
      });
    });
  }

  function initProductPage() {
    if (!document.body.classList.contains('template-product')) return;

    cancelAllScrollTriggers();

    document.querySelectorAll('.product__media-wrapper img, .thumbnail-list img, .related-products img').forEach((img) => {
      img.style.opacity = '1';
    });

    const gallery = document.querySelector('.product__media-wrapper');
    const info = document.querySelector('.product__info-wrapper');
    [gallery, info].forEach((el) => {
      if (!el) return;
      el.classList.remove('ffs-reveal');
      el.classList.add('ffs-reveal--visible');
    });
  }

  function initHeroVideoPosters() {
    /* Poster visibility is handled by CSS + global.js play/reset.
       Do not force video opacity:0 — that caused permanent black screens. */
  }

  function init() {
    unlockPageScroll();
    try {
      initCrossfadeSlideshow();
      initHeader();
      initReveals();
      initCommercePages();
      initProductPage();
      initHeroVideoPosters();
    } catch (error) {
      console.error('ffs-motion init failed', error);
    } finally {
      bootPage();
    }
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      unlockPageScroll();
      cancelAllScrollTriggers();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
